export function normalizeLambdaWebhookHeaders<T extends { headers?: Record<string, string> | null }>(event: T): T {
    const headers = event?.headers;
    if (!headers || headers['X-Telegram-Bot-Api-Secret-Token']) return event;

    const secretToken = headers['x-telegram-bot-api-secret-token'];
    return secretToken ? ({ ...event, headers: { ...headers, 'X-Telegram-Bot-Api-Secret-Token': secretToken } } as T) : event;
}
